// extracted by mini-css-extract-plugin
module.exports = {"container":"_3MJ7wGO72j2NyaL6K6TbIm","visible":"PZd3tj-qmDEt13mGDMw0K","cancelBtn":"_33DUKzIf-DiTr_ieKA_d8m","icon":"_3dJWf3cui2rFXnNpcd0pgM","saveBtn":"_3T_lgQClvuyvJENT1_TGbc"};